import React from "react";
import { useApp } from "../context/AppContext";

export function DayNavigator() {
  const { config, schedule, selectedDay, setSelectedDay } = useApp();
  if (!config) return null;
  const perDay = schedule?.stats?.per_day || [];

  return (
    <div className="flex items-stretch gap-1.5 mb-4 overflow-x-auto pb-1" data-testid="day-navigator">
      {config.days.map((d) => {
        const stat = perDay.find((p) => p.day === d.index);
        const active = selectedDay === d.index;
        const crit = stat?.critical_uncovered || 0;
        const cov = stat?.coverage_pct;
        const dotColor = !stat ? "bg-faint" : crit > 0 ? "bg-critical" : "bg-success";
        return (
          <button
            key={d.index}
            data-testid={`day-tab-${d.index}`}
            onClick={() => setSelectedDay(d.index)}
            className={`flex-1 min-w-[92px] px-3 py-2 rounded-sm border text-left transition-colors duration-150 ${
              active
                ? "bg-primary/15 border-primary/40"
                : "bg-surface border-line hover:border-lineFocus"
            }`}
          >
            <div className="flex items-center justify-between">
              <span className={`head text-xs font-semibold tracking-tight ${active ? "text-ink" : "text-muted"}`}>
                {d.label}
              </span>
              <span className={`w-1.5 h-1.5 rounded-full ${dotColor}`} />
            </div>
            <div className="mono text-[10px] text-faint mt-0.5">{d.date.slice(5)}</div>
            <div className={`mono text-xs mt-1 ${active ? "text-primary" : "text-muted"}`}>
              {cov !== undefined ? `${cov}%` : "—"}
            </div>
          </button>
        );
      })}
    </div>
  );
}
